import Vue from 'vue'
import BootstrapVue from "bootstrap-vue";
import VModal from 'vue-js-modal';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faAngleDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import VueMeta from 'vue-meta';
import Vuelidate from 'vuelidate';
import App from '@/App.vue'
import {i18n} from "@/i18n/i18";
import router from '@/config/router'
import "@/config/ym";

const VueMq = require('vue-mq');
const VueGoogleMaps = require('vue2-google-maps');

Vue.use(VueMq, {
    breakpoints: {
        sm: 767,
        md: 768,
        lg: Infinity,
    }
})
Vue.use(BootstrapVue);
Vue.use(VModal);
Vue.use(VueMeta);
Vue.config.productionTip = false;
library.add(faAngleDown);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBgykX4aQkqIhwOquZ1CyQVAZCETJmi_2U',
        libraries: 'places',
    },
});
Vue.use(Vuelidate)
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App),
});
